import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsIssueSourcesRoute: InvariantJiraRoute = {
	name: 'plan-settings-issue-sources',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources',
};
